import { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import api from '../lib/api'

export interface Establishment {
  id: string
  name: string
  city: string | null
  address: string | null
}

interface EstablishmentContextType {
  establishments: Establishment[]
  current: Establishment | null
  setCurrent: (e: Establishment) => void
}

const EstablishmentContext = createContext<EstablishmentContextType>({
  establishments: [],
  current: null,
  setCurrent: () => {}
})

export function EstablishmentProvider({ children }: { children: ReactNode }) {
  const [establishments, setEstablishments] = useState<Establishment[]>([])
  const [current, setCurrent] = useState<Establishment | null>(null)

  useEffect(() => {
    api.get('/establishments').then(r => {
      const list: Establishment[] = Array.isArray(r.data) ? r.data : []
      setEstablishments(list)
      // Restaurer le dernier choix ou prendre le premier
      const savedId = localStorage.getItem('selectedEstablishmentId')
      const found = list.find(e => e.id === savedId) || list[0] || null
      setCurrent(found)
    }).catch(() => {})
  }, [])

  function select(e: Establishment) {
    setCurrent(e)
    localStorage.setItem('selectedEstablishmentId', e.id)
  }

  return (
    <EstablishmentContext.Provider value={{ establishments, current, setCurrent: select }}>
      {children}
    </EstablishmentContext.Provider>
  )
}

export function useEstablishment() {
  return useContext(EstablishmentContext)
}
